import { z } from 'zod/mini'

import { itemObject } from './fields'
import { gtmMetadataShape } from './gtm-metadata'
import { listItemShape } from './item'
import { nonEmptyString } from './non-empty-string'

export const viewItemListSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_item_list'),
  ecommerce: z.strictObject({
    // Market currency
    currency: nonEmptyString(),
    // Zone, component, or list name: the list must be identifiable
    item_list_id: nonEmptyString(),
    item_list_name: z.string(),
    // Only sent when at least one item became visible
    items: z.array(itemObject(listItemShape)).check(z.minLength(1)),
  }),
})
